module.exports = __webpack_public_path__ + "img/slogan.17d39b7f.png";